import BaseService from "./geral/BaseService";
import moment from 'moment'
import { objetoParaQueryString } from '../utils/formatar';
import lscache from "lscache";

const base = "ProgNavio";

export default class ProgramacaoNaviosService extends BaseService {
    constructor(isSSA) {
        super(base);
    }

    listar(filtro){
        this.adicionarQtdPaginas(filtro);
        let str = objetoParaQueryString(filtro);
        return super.httpGet(`/${base}?${str}`, false);
    }

    adicionarQtdPaginas(filtro){
        filtro["tamanhoPagina"] = this.tamanhoPagina;
        return filtro;
    }

    buscarFiltrosVisualizacao() {
        if(lscache.get('MembershipuserId')){
            return super.httpGet(`/${base}/ListarFiltros?membershipuserId=${lscache.get('MembershipuserId')}`);
        }else{
            return Promise.resolve({data: [this.filtro]})
        }
    };

    salvarFiltrosVisualizacao(filtros) {
        filtros.DataUltimaModificacao = moment().format();
        return super.httpPost(`/${base}/SalvarFiltro`, filtros);
    }

    predefinicao = {
        valor : "0", nome: "Padrão", descricao : "",
        dadosTabela : ["F1", "F2", "F3", "F4", "F5", "F6", "F8", "F9", "F10", "F15"],
        situacoes : [ "Todos" ]
    };

    filtro = {
        Id: 0,
        ApplicationId: 1,
        TaskId: 1,
        OperationId: 1,
        TipoObjeto: "FILTRO",
        NomeObjeto: "",
        DescricaoObjeto: "Filtro Programação de Navios",
        MembershipuserId: 0,
        ValorObjeto: JSON.stringify(this.predefinicao),
        DataUltimaModificacao: moment().format()
    }

    todosDadosTabela = (isSSA) => {
        let dados = [
            {id: "F1", label: "Navio / Viagem"},
            {id: "F2", label: "Deadline Dry"},
            {id: "F3", label: "Serviço"},
            {id: "F4", label: "Situação"},
            {id: "F5", label: "Berço"},
            {id: "F6", label: "Armador"},
            {id: "F7", label: "País"},
            {id: "F8", label: "ETA"},
            {id: "F9", label: "ETB"},
            {id: "F10", label: isSSA ? "ETD" : "ETS"},
            {id: "F12", label: "Tipo"},
            {id: "F13", label: "Comprimento"},
            {id: "F14", label: "Largura"},
            {id: "F15", label: "Movs"},
            {id: "F16", label: "Lloyds"},
            {id: "F17", label: "N de ROWS"},
            {id: "F18", label: "De / Para"},
            {id: "F19", label: "Atracação"},
            {id: "F20", label: "Desatracação"},
            {id: "F21", label: "Início Real"},
            {id: "F22", label: "Fim Real"},
            {id: "F23", label: "Callsign"},
            {id: "F24", label: "Escala Siscarga"},
            {id: "F25", label: "Liberação RFB"},
            {id: "F26", label: "Início Recebimento (Vazio)"},
            {id: "F27", label: "Início Recebimento (Cheio)"},
            {id: "F28", label: "Prático a Bordo (Atracação)"},
            {id: "F29", label: "Prático a Bordo (Desatracação)"}
        ];
        if (isSSA) dados.push({id: "F30", label: "Chegada na Barra"});
        return dados;
    }
}


// WEBPACK FOOTER //
// ./src/services/ProgramacaoNaviosService.js